import { type LatLng } from '~/_shared/types/latLng';
import type { SpreadsheetRowId } from '~/_shared/types/spreadsheetData/spreadsheetRow';

export type MarkersContextMenuPosition = {
  latLng: LatLng;
  offset: { x: number; y: number };
};

type MarkersContextMenuInactiveState = {
  visible: false;
  position: null;
  rowIds: null;
};

type MarkersContextMenuActiveState = {
  visible: true;
  position: MarkersContextMenuPosition;
  rowIds: ReadonlyArray<SpreadsheetRowId>;
};

export type MarkersContextMenuState = MarkersContextMenuActiveState | MarkersContextMenuInactiveState;

export const isMarkersContextMenuActive = (
  state: MarkersContextMenuState
): state is MarkersContextMenuActiveState => state.visible;
